import { useStaticQuery, graphql } from "gatsby"

export const useMainMenuQuery = () => {
  const { mainMenuItems, mainMenuDropdownImages, sidebarMenuTitle } = useStaticQuery(
    graphql`
    query MainMenuQuery {
      mainMenuItems: allWpMenuItem(
        filter: {parentDatabaseId: {eq: 0}, locations: {eq: PRIMARY_MENU}}
      ) {
        nodes {
          label
          path
          menuIcons {
            menuIconsIcon {
              localFile {
                childSvg {
                  content {
                    data
                  }
                }
              }
            }
          }
          childItems {
            nodes {
              label
              path
              childItems {
                nodes {
                  label
                  path
                }
              }
              id
            }
          }
          cssClasses
          id
        }
      }
      mainMenuDropdownImages: wpMenu(locations: {eq: PRIMARY_MENU}) {
        mainMenuImages {
          mainMenuImageContainer {
            mainMenuImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE)
                }
              }
            }
            mainMenuAltText
          }
        }
      }
      sidebarMenuTitle:  wp {
        acfOptionsCommonItems {
          commonItems {
            commonItemsSidebarMenuTitle
          }
        }
      }
    }
    `
  )
  return { mainMenuItems, mainMenuDropdownImages, sidebarMenuTitle }
}
